import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
// import { InertiaProgress } from '@inertiajs/progress'
// import { createInertiaApp } from '@inertiajs/inertia-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VTooltip from 'v-tooltip'
import VueLoaders from 'vue-loaders'
import Vue2Filters from 'vue2-filters'
import VueClipboard from 'vue-clipboard2'
import VueMoment from 'vue-moment'
import VueCookies from 'vue-cookies'
import route from 'ziggy'

require('./bootstrap')
require('./axios')
require('../css/fake.css') // https://github.com/JeffreyWay/laravel-mix/issues/2064#issuecomment-511364566

if (process.env.NODE_ENV === 'production') {
    const { Ziggy } = require('./routes') // eslint-disable-line global-require
    Vue.mixin({ methods: { route: (name, params, absolute) => route(name, params, absolute, Ziggy) } })
} else {
    Vue.mixin({ methods: { route: window.route } })
}

Vue.config.productionTip = false
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueAxios, axios)
Vue.use(VTooltip)
Vue.use(VueLoaders)
Vue.use(Vue2Filters)
Vue.use(VueClipboard)
Vue.use(VueMoment)
Vue.use(VueCookies)

InertiaProgress.init()

/* createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props }) {
        new Vue({
            metaInfo: {
                titleTemplate: title => (title ? `${title} - ColdLead.io` : 'ColdLead.io')
            },
            render: h => h(app, props)
        }).$mount(el)
    }
}) */
const el = document.getElementById('app')

new Vue({
    metaInfo: {
        titleTemplate: title => (title ? `${title} - ColdLead.io` : 'ColdLead.io')
    },
    render: h =>
        h(App, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default)
            }
        })
}).$mount(el)

window.bus = new Vue()
